module.exports = __webpack_public_path__ + "static/shrj-b48f6642119ee56b8afca6a532249219.jpg";